"use client";

import Image from "next/image";

export default function MobileHomeHeader() {
  return (
    <div className='relative w-full h-[45vh] flex items-center justify-center overflow-hidden'>
      <Image
        src='/assets/mobile-home.webp'
        alt='Header'
        fill
        sizes='100vw'
        className='object-cover'
        style={{
          objectFit: "cover",
          containIntrinsicSize: "100vw 45vh",
        }}
        priority
        fetchPriority='high'
        loading='eager'
        decoding='async'
      />
    </div>
  );
}
